import React from "react";
import "./HrOrderShell.scss";

/**
 * Root wrapper for order-summary screens: width, RTL, optional states.
 */
export function HrOrderPage({
  children,
  className = "",
  loading = false,
  loaded = true,
  narrow = false,
  withMobileBar = false,
  dir = "rtl",
}) {
  return (
    <div
      dir={dir}
      className={
        "hr-order-page" +
        (loading ? "" : loaded ? " hr-order-page--loaded" : "") +
        (narrow ? " hr-order-page--narrow" : "") +
        (withMobileBar ? " hr-order-page--with-mobile-bar" : "") +
        (className ? ` ${className}` : "")
      }
    >
      {children}
    </div>
  );
}
